import $ from 'jquery';
import { getScrollTop, getWidth, onScroll } from '../utils/window';

export default function headerSection() {
	const $html = $('html');
	const $scroller = $('html, body');

	const $header = $('#header');
	const $headerNav = $('#header-nav');
	const headerToggler = $headerNav.data('toggler');

	const secondary = $('#secondary-menu');
	const secondaryToggler = secondary.data('toggler');
	const secondaryTitle = $('.project-nav_title');

	const navParents = $('.-parent.-level-1');

  // this is so the sub sub menu heights are consitent visually
  const subMenuParents = document.querySelectorAll('#header-nav li.-parent.-level-2');
  subMenuParents.forEach(element => {
    element.addEventListener('mouseenter', event => {

      let childMenu = element.querySelector('ul');
      let paddingBuffer = 20;

      childMenu.height = 'auto';
      element.parentElement.style.height = 'auto';

      if (getWidth() >= 1080) {
        if (element.parentElement.clientHeight > childMenu.clientHeight) {
          childMenu.style.height =`${element.parentElement.clientHeight - paddingBuffer}px`;
        } else {
          element.parentElement.style.height = `${childMenu.clientHeight + paddingBuffer}px`;
        }
        element.parentElement.classList.add('-expanded');
      }
    });
    element.addEventListener('mouseleave', event => {
      element.parentElement.classList.remove('-expanded');
    });
  });

	if (headerToggler) {

		headerToggler.on('toggle', function() {
			$html.toggleClass('is-header-open', headerToggler.isOpen);

			if (headerToggler.isOpen) {
				$scroller.animate({ scrollTop: 0 }, { duration: 200 });
			}
		});
	}

	if (secondaryToggler) {
		const links = $('.project-nav_link > a');
		links.click(function() {
			if (secondary.hasClass('is-open')) {
				secondaryTitle.click();
			}
		});

		onScroll(() => {
			links.each(function(index, el) {
				const $el = $(el);
				const href = $el.attr('href');
				const actualElement = $(href);
				const st = getScrollTop();

				if (actualElement.length && st >= actualElement.offset().top && st <= (actualElement.offset().top + actualElement.height())) {
					links.removeClass('in-view');
					$el.addClass('in-view');
				}
			});
		});
	}

	if (navParents.length) {
		navParents.each(function() {
			const parent = $(this);
			const anchor = parent.find('> a i');
			const submenu = parent.find('> ul');

			anchor.on('click', function(e) {
				e.preventDefault();

				if (!parent.hasClass('is-open')) {
					$('.-parent.is-open').slideUp(400);
				}

				if (getWidth() < 1080) {
					submenu.slideToggle(400);
					parent.toggleClass('is-open');
					anchor.toggleClass('is-open');
				} else {
					window.location.href = anchor.attr('href');
				}

			});
		});
	}

	let isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
	if (isSafari) {
		$('html').addClass('is-safari');
	}

  /** search */
  const searchButton = document.querySelector('.header_search_button');
  const searchWindow = document.querySelector('.header_search_window');
  const searchCloseButton = document.querySelector('.header_search_window-inner button');
  if (searchButton) {
    searchButton.addEventListener('click', event => {
      if (searchWindow.classList.contains('closed')) {
        searchWindow.querySelector('input').focus();
      }
      searchWindow.classList.replace('closed', 'open');
    });
    searchCloseButton.addEventListener('click', event => {
      searchWindow.classList.replace('open', 'closed');
    });
  }
}



// WEBPACK FOOTER //
// ./source/scripts/sections/header.js